// extracted by mini-css-extract-plugin
export default {"title":"recommendPerformance_title__ajJZU"};